// removed by extract-text-webpack-plugin
module.exports = {"header":"header___5Mia0","header__top":"header__top___3qiVC","header__logo-link":"header__logo-link___33ws1","header__logo-item":"header__logo-item___Ez_kH","menu":"menu___29_Ot","menuLinks":"menuLinks___fZ1Ex","menuLinks__item-right":"menuLinks__item-right___2AYW7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Header/Header.module.scss
// module id = 2735
// module chunks = 0